import { FormattedMessage } from 'react-intl';
import { useNavigate } from '@tanstack/react-router';
import { SearchX } from 'lucide-react';

import { Button } from '@/components/ui/base/button';
import { Empty } from '@/modus/Empty';

export function NotFound() {
  const navigate = useNavigate();

  return (
    <main className="h-screen w-screen flex items-center justify-center">
      <Empty.Root className="p-1">
        <Empty.Header>
          <Empty.Media variant="icon">
            <SearchX className="size-5" />
          </Empty.Media>
          <Empty.Title>
            <FormattedMessage id="notFound.title" defaultMessage="Page not found" />
          </Empty.Title>
          <Empty.Description>
            <FormattedMessage id="notFound.description" defaultMessage="The page you are looking for does not exist." />
          </Empty.Description>
        </Empty.Header>
        <Empty.Content>
          <Button size="sm" onClick={() => navigate({ to: '/' })}>
            <FormattedMessage id="notFound.cta" defaultMessage="Go to Home" />
          </Button>
        </Empty.Content>
      </Empty.Root>
    </main>
  );
}
